import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import { getAnnualSales, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Body from './Body';
import Header from './Header';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportAnnualSalesCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon'
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class AnnualSales extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 25,
            showBody: false,
            model: {
                year: 0,
                branch: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }
    componentWillMount() {
        const date = new Date();
        this.props.formInput(date.getFullYear(), `AnnualSalesYear`);
    }

    downloadReport = () => {
        let branch = this.props.branch || this.props.loggedBranch;
        let year = this.props.year || moment().format('YYYY');
        this.props.getCsvReport(`reports/excel/annualsales?year=${year}&branchId=${branch}`, "annualsales");
    }


    resetPagination = (page) => {
        this.setState({ activePage: page ? page : 1 });
    }

    changePage = (e) => {
        this.resetPagination(e);
    }

    getReport = () => {
        let year = this.props.year || moment().format('YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        this.props.getAnnualSales({ year, branch });
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    cleanSearch = () => {
        this.props.clearFormInput(`AnnualSalesYear`);
        this.props.clearFormInput(`AnnualSalesBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        return (
            <Grid headerContent={reportAnnualSalesCrumb}>
                <PageHeader title={LOOKUP.report.annualSales.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-annual-sales-summary-report" />}
                    description={LOOKUP.report.annualSales.description}
                />
                <Header
                    loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body
                            annualSales={this.props.annualSales}
                            searchedYear={this.props.year}
                            searchedBranch={this.props.branchText}
                            loggedBranch={this.props.loggedBranch}
                            userBranch={this.props.userBranchText}
                        />
                        <DateCurrentDisplay />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        annualSales: state.reports.annualSales,
        loggedBranch: state.common.branchId,
        year: state.form.AnnualSalesYear,
        branch: state.form.AnnualSalesBranchOption,
        branchText: state.form.AnnualSalesBranchOptionText,
        userBranchText: state.common.userBranches
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAnnualSales: model => dispatch(getAnnualSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(AnnualSales));